import {RadioGroup as HUIRadioGroup} from '@headlessui/react'
import {forwardRef} from 'react'

import {twMerge} from '@sdox/utils'

import {Radio} from './Radio'

import type {RadioProps} from './Radio'
import type {RadioGroupProps as HUIRadioGroupProps} from '@headlessui/react'

export interface RadioGroupProps extends HUIRadioGroupProps<'div', RadioProps['value']> {
  className?: string
  items: RadioProps[]
  onChange?: (value: string) => void
}

export const RadioGroup = forwardRef<HTMLElement, RadioGroupProps>(
  ({className, items, onChange, ...restProps}, ref) => (
    <HUIRadioGroup
      ref={ref}
      onChange={onChange}
      className={twMerge('w-full gap-4', className)}
      {...restProps}
    >
      {items.map((item, index) => (
        <Radio
          key={index}
          {...item}
        />
      ))}
    </HUIRadioGroup>
  ),
)
